<template>
    <BButtonGroup>
        <BButton
            v-for="btn in buttons"
            :key="btn.id"
            :variant="{ false: 'outline-dark', true: 'dark' }[btn.id == value]"
            :style="{ color: btn.color }"
            @click="click(btn.id)"
            >{{ btn[textField] }}
        </BButton>

        <BButton
            v-if="other_buttons.length <= 0 && !disableMore && allowUnselect"
            variant="outline-secondary"
            :style="{ color: 'black' }"
            @click="unselect()"
            >Unselect
        </BButton>

        <BDropdown
            v-if="other_buttons.length > 0 && !disableMore"
            right
            text=""
            variant="outline-dark"
        >
            <BDropdownForm
                v-if="all_other_buttons.length > maxMoreItems"
                class="p-0"
            >
                <BFormInput
                    v-model="search"
                    autofocus
                    type="search"
                ></BFormInput>
            </BDropdownForm>
            <BDropdownItemButton
                v-for="o in other_buttons"
                :key="o.id"
                :active="o.id == value"
                @click="click(o.id)"
                ><span v-if="o.id == value">&#10003;</span>{{ o[textField] }}
            </BDropdownItemButton>
            <BDropdownDivider v-if="allowUnselect"></BDropdownDivider>
            <BDropdownItemButton v-if="allowUnselect" @click="unselect()"
                >Unselect
            </BDropdownItemButton>
        </BDropdown>
    </BButtonGroup>
</template>

<script>
import {
    BButton,
    BButtonGroup,
    BDropdown,
    BDropdownDivider,
    BDropdownForm,
    BDropdownItemButton,
    BFormInput,
} from "bootstrap-vue";
import _ from "lodash";
import { filter_active_list } from "@/vue-ocom/utils/active.js";

export default {
    name: "OSpeedSelect",
    components: {
        BButtonGroup,
        BButton,
        BDropdown,
        BDropdownForm,
        BFormInput,
        BDropdownItemButton,
        BDropdownDivider,
    },
    model: {
        prop: "value",
        event: "input",
    },
    props: {
        validator: { type: Object, default: null },
        formState: { type: Object, default: null },
        items: { type: Array, default: null },
        value: { type: Number },
        textField: { type: String, default: "description" },
        quickDisplayOrderField: {
            type: String,
            default: "quick_display_order",
        },
        disableMore: { type: Boolean, default: false },
        maxMoreItems: { type: Number, default: 10 },
        allowUnselect: { type: Boolean, default: false },
    },
    data() {
        return {
            search: "",
        };
    },
    computed: {
        buttons() {
            const vm = this;

            return _.sortBy(
                _.filter(this.items, function (o) {
                    if (vm.quickDisplayOrderField) {
                        return !!o[vm.quickDisplayOrderField];
                    } else {
                        return true;
                    } // No quickDisplayOrderField so return all
                }),
                vm.quickDisplayOrderField,
            );
        },
        all_other_buttons() {
            const vm = this;

            return _.sortBy(
                _.filter(filter_active_list(this.items), function (o) {
                    if (vm.quickDisplayOrderField) {
                        return !o[vm.quickDisplayOrderField];
                    } else {
                        return false; // no extras
                    }
                }),
                this.textField,
            );
        },
        other_buttons() {
            var items = this.all_other_buttons;
            const vm = this;

            const search = vm.search || "";

            // Filter by search
            items = _.filter(items, function (o) {
                const textValue = o[vm.textField] || "";

                return textValue.includes(search);
            });

            return _.slice(items, 0, vm.maxMoreItems);
        },
    },
    methods: {
        unselect() {
            this.$emit("input", null);
        },
        click(btnID) {
            if (this.validator) {
                this.validator.$touch();
            }
            if (this.formState) this.formState.dirty = true;

            this.$emit("input", btnID);
        },
    },
};
</script>

<style scoped></style>
